<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cities"
      :search="searchField"
      :loading="loading"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 nowrap-headers"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index == activeRow }"
          class="tableRowColor"
          @click="activeRow = index"
        >
          <td class="text-xs">
            <span v-if="item.state"> {{ item.state.name }} </span>
          </td>
          <td class="text-xs">
            {{ item.name }}
          </td>
          <td class="text-xs">
            {{ item.lat }}
          </td>
          <td class="text-xs">
            {{ item.long }}
          </td>
          <td
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            class="justify-center"
          >
            <v-row row>
              <v-icon
                class="mr-2 pointer"
                variant="text"
                color="grey-darken-2"
                @click="editCity(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                class="pointer"
                variant="text"
                color="grey-darken-2"
                @click="deleteCity(item._id)"
              >
                mdi-delete
              </v-icon>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  data: () => ({
    loading: false,
    searchField: "",
    valid: false,
    headers: [
      {
        title: "",
        sortable: false,
        key: "state",
      },
      {
        title: "",
        sortable: false,
        key: "name",
      },
      {
        title: "",
        sortable: false,
        key: "lat",
      },
      {
        title: "",
        sortable: false,
        key: "long",
      },
      {
        title: "",
        sortable: false,
      },
    ],
    cities: [],
    activeRow: null,
    dialogDelete: false,
    cityToDelete: null,
  }),
  created() {
    this.getLocale();
    this.getCities();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("cities.table.state");
      this.headers[1].title = this.$t("cities.table.name");
      this.headers[2].title = this.$t("cities.table.lat");
      this.headers[3].title = this.$t("cities.table.long");
      this.headers[4].title = this.$t("cities.table.actions");
    },
    search(value) {
      this.searchField = value;
    },
    getCities() {
      this.loading = true;
      getRequest("/city/")
        .then((response) => {
          this.cities = response.cities;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editCity(city) {
      this.$emit("edit", city);
    },
    deleteCity(cityId) {
      this.cityToDelete = cityId;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/city/", `id=${this.cityToDelete}`).then((response) => {
        if (response.status === 200) {
          this.cityToDelete = null;
          this.dialogDelete = false;
          this.loading = false;
          this.getCities();
        }
      });
    },
  },
};
</script>
